/*
  Like the standard react-redux connect, but allows an object shorthand
  for `mapStateToProps`, where the keys are the prop names and the values
  are selectors that take the state and props as arguments.
*/

import isFunction from "lodash/isFunction";
import mapValues from "lodash/mapValues";
import { Dispatch } from "react";
import { connect as reactReduxConnect } from "react-redux";
import type { Action, AnyAction } from "redux";

type PropSelector = (state: unknown, props?: Record<string, unknown>) => unknown;
type MapStateToProps =
  | ((state: unknown, props?: Record<string, unknown>) => Record<string, unknown>)
  | Record<string, PropSelector>;
type MapDispatchToProps =
  | ((dispatch: Dispatch<Action>, props?: Record<string, unknown>) => Record<string, unknown>)
  | Record<string, (...args: unknown[]) => AnyAction>;

export default function connect(mapStateToProps: MapStateToProps, mapDispatchToProps?: MapDispatchToProps) {
  if (!isFunction(mapStateToProps)) {
    const propSelectors = mapStateToProps;
    mapStateToProps = function (state: unknown, props?: Record<string, unknown>) {
      const callSelector = (selector: PropSelector) => selector(state, props);
      return mapValues(propSelectors, callSelector);
    };
  }

  return reactReduxConnect(mapStateToProps, mapDispatchToProps);
}
